import React from "react";
import { useAuth } from "../../contexts/authContext";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Dropdown, Button } from "antd";

import { commonUtil } from "../../utils";

const UserInfo = () => {
  const { t } = useTranslation(["common", "notification"]);
  const auth = useAuth();
  const history = useHistory();

  const onClickAccountInfo = () => {
    history.push("/profile");
  };

  const onClickLogout = () => {
    commonUtil.deleteSession();
    auth.logout();
    history.push("/login");
  };

  const menuProfile = (
    <div className="profile-dropdown">
      {/* ` <Button
        className="profile-dropdown-item"
        type="link"
        block={true}
        onClick={onClickAccountInfo}
      >
        <IconUserFilled />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        {t("common:Thông tin cá nhân")}
      </Button>` */}
      <Button
        className="w-fit"
        type="primary"
        block={true}
        style={{ marginTop: "10px" }}
        onClick={onClickLogout}
      >
        {t("common:Đăng xuất")}
      </Button>
    </div>
  );

  const getDisplayName = () => {
    if (!auth || !auth.user) {
      return "";
    }
    if (auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name + " " + auth.user.first_name;
    }
    if (auth.user.first_name && !auth.user.last_name) {
      return auth.user.first_name;
    }
    if (!auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name;
    }
    return auth.user.phone || auth.user.email || "User";
  };

  return (
    <Dropdown
      overlay={menuProfile}
      trigger={["click"]}
      placement="bottomRight"
      arrow={true}
    >
      <div className="flex items-center font-medium cursor-pointer">
        {/* <img
          className="h-40 w-40 rounded-full"
          src="https://images.unsplash.com/photo-1594733813181-5058a6592fb8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        /> */}

        <div className="flex flex-col items-start">
          {getDisplayName()}
          <span className="text-red-primary font-medium text-sm">
            {t(`common:${commonUtil.formatRole(auth?.user?.business_role)}`)}
          </span>
        </div>
      </div>
    </Dropdown>
  );
};

export default UserInfo;
